module.exports = __webpack_public_path__ + "static/background-c9acf7600acfaa88bd63f70b4d321efb.jpg";